import React, { useRef, useCallback } from 'react'

export interface FloatingLabelWrapperProps {
  label: string
  required?: boolean
  children: React.ReactNode
}

export function FloatingLabelWrapper({ label, required, children }: FloatingLabelWrapperProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  const handleContainerClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    // 이미 input이나 버튼을 클릭한 경우는 무시
    const target = e.target as HTMLElement
    if (target.tagName === 'INPUT' || target.tagName === 'BUTTON' || target.closest('button') || target.closest('input')) {
      return
    }

    const container = containerRef.current
    if (!container) return

    const inputs = container.querySelectorAll('.react-datetimerange-picker__inputGroup__input')
    if (inputs.length > 0) {
      const firstInput = inputs[0] as HTMLInputElement
      firstInput.click()
      firstInput.focus()
    }
  }, [])

  return (
    <div ref={containerRef} style={{ position: 'relative', cursor: 'pointer' }} onClick={handleContainerClick}>
      <div
        style={{
          position: 'absolute',
          top: -9,
          left: 12,
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          paddingLeft: 4,
          paddingRight: 2,
          backgroundColor: '#ffffff',
        }}
      >
        <span style={{ fontSize: 12, lineHeight: 1.5, color: '#8a8a8a' }}>{label}</span>
        {required && <span style={{ fontSize: 12, color: '#245eff' }}>*</span>}
      </div>
      {children}
    </div>
  )
}
